module.exports = __webpack_public_path__ + "img/PL00236.f485392a.png";